import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './HouseFacilities.scss';

const HouseFacilities = ({ imageOne, imageTwo }) => {
  return (
    <div className='house-fac'>
      <Container>
        <h1 className='house-fac__title'>Fasilitas Bangunan dan Ruangan</h1>
        <Row className='house-fac__list-row'>
          <Col xs={12}>
            <p className='house-fac__text'>Kami menyediakan hal-hal yang penting agar anda merasa nyaman</p>
          </Col>
          <Col md={6} lg={{ span: 3, offset: 3 }}>
            <ul className='house-fac__list'>
              <li>Air Conditioning</li>
              <li>Fully Furnished</li>
              <li>24Hr Security & CCTV</li>
              <li>Intercom</li>
              <li>Room Cleaning</li>
              <li>Laundry</li>
            </ul>
          </Col>
          <Col md={6} lg={3}>
            <ul className='house-fac__list'>
              <li>Wi-Fi</li>
              <li>Kitchen</li>
              <li>Guest Area</li>
              <li>Parking Area</li>
              <li>Common Area</li>
              <li>Dispenser</li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col md={6} lg={6}>
            <div className='house-fac__img-wrapper'>
              <img alt='' className='house-fac__img' src={imageOne} />
            </div>
          </Col>
          <Col md={6} lg={{ span: 4, offset: 1 }}>
            <div className='house-fac__img-wrapper'>
              <img alt='' className='house-fac__img' src={imageTwo} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HouseFacilities;
